import { Component, computed, inject } from "@angular/core";
import { RouterLink } from "@angular/router";
import {
  NbActionsModule,
  NbContextMenuModule,
  NbIconModule,
  NbMenuItem,
  NbMenuModule,
  NbMenuService,
  NbUserModule,
} from "@nebular/theme";
import { CourseService } from "app/@core/services/course.service";
import { UserService } from "app/@core/services/users.service";
import { MENU_ITEMS, USER_MENU } from "app/app-menu";

@Component({
  standalone: true,
  selector: "ngx-header",
  styleUrls: ["./header.component.scss"],
  templateUrl: "./header.component.html",
  imports: [
    NbMenuModule,
    NbActionsModule,
    NbUserModule,
    NbContextMenuModule,
    NbIconModule,
    RouterLink,
  ],
})
export class HeaderComponent {
  private menuService = inject(NbMenuService);
  private userService = inject(UserService);
  private courseService = inject(CourseService);

  user = this.userService.user;

  private readonly RAW_MENU: NbMenuItem[] = MENU_ITEMS;
  userMenu: NbMenuItem[] = USER_MENU;

  readonly mainMenu = computed(() => {
    const hasAces = this.courseService.hasAces();
    const hasAiPlayGround = this.courseService.hasAiPlayGround();
    const isAdmin = this.userService.isAdmin();

    return this.RAW_MENU.map((item) => ({
      ...item,
      hidden:
        item.title === "ACES"
          ? !hasAces
          : item.title === "AI Playground"
            ? !hasAiPlayGround
            : item.title === "Admin"
              ? !isAdmin
              : item.hidden,
    }));
  });
}
